export namespace CouponConstants {

    export enum CouponType {
        DISCOUNT = 'DISCOUNT',
        SETTLEMENT = 'SETTLEMENT'
    }

}